document.addEventListener('DOMContentLoaded', function() {
  const fingerSection = document.getElementById('BoltsSiteFinger');
  
  if (fingerSection) {
    const closeButton = fingerSection.querySelector('.bolts-site-finger__close');

    // Set the 2-second timeout
    setTimeout(() => {
      // FIX: Removed the line 'fingerSection.style.display = 'flex';'
      // We only need to add the class to trigger the CSS transition.
      fingerSection.classList.add('is-active');
    }, 2000); 

    // Add click event listener to the close button
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        // We'll hide it by removing the 'is-active' class
        // and letting it fade out.
        fingerSection.classList.remove('is-active');
        
        // Optional: you can set it to display:none *after* the
        // fade-out transition is complete (0.5s)
        setTimeout(() => {
           fingerSection.style.display = 'none';
        }, 500); // Must match your CSS transition duration
      });
    }
  }
});